import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

// TODO: Replace with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyBwD_ESB8nvGKGoLntnMHJsc79vQU1XVSE",
  authDomain: "zedfo-8f5f8.firebaseapp.com",
  projectId: "zedfo-8f5f8",
  storageBucket: "zedfo-8f5f8.firebasestorage.app",
  messagingSenderId: "575102689742",
  appId: "1:575102689742:web:3b66257a0a39d4f717cb9f",
  measurementId: "G-M1SH479D6Z",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Conditional messaging initialization
let messaging: any = null;

isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
  } else {
    console.warn("Firebase Messaging is not supported in this browser environment.");
  }
}).catch(err => {
  console.error("Error checking Firebase Messaging support:", err);
});

export { messaging, getToken, onMessage, isSupported };
export default app;
